export function SET_FILTERS({ commit }, [progress, search, selected_areas, selected_groups, selected_tags]) {
    commit('SAVE_FILTERS', [progress, search, selected_areas, selected_groups, selected_tags])
}

export function SET_LIVE_CLASS_STATUS({ commit }, [live_class_status]) {
    commit('SAVE_LIVE_CLASS_STATUS', [live_class_status])
}

export function SET_LIVE_CLASS_IS_ONLINE({ commit }, [live_class_is_online]) {
    commit('SAVE_LIVE_CLASS_IS_ONLINE', [live_class_is_online])
}

export function SET_PROGRESS({ commit }, progress) {
    commit('SAVE_PROGRESS', progress)
}

export function SET_FILTER_AREA({ commit }, selected_areas) {
    commit('SAVE_FILTER_AREA', selected_areas)
}

export function SET_LOADING({ commit }, loading) {
    commit('SAVE_LOADING', loading)
}